import React from 'react';
import AppRouter from '../routes';
import CookieBot from 'react-cookiebot';
import ErrorBoundary from '../views/components/error-boundary';
import { MantineProvider, createTheme } from '@mantine/core';
import { DebugBar } from '../views/components/debug';

const theme = createTheme({
  /** Put your mantine theme override here */
});

const domainGroupId = process.env.REACT_APP_COOKIEBOT_DOMAIN_ID ?? '';
const debugMode = process.env.REACT_APP_DEBUG_MODE;

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <MantineProvider theme={theme}>
        <AppRouter />
        <CookieBot domainGroupId={domainGroupId} />
        {debugMode === 'true' && <DebugBar />}
      </MantineProvider>
    </ErrorBoundary>
  );
};

export default App;
